import { CatalogosPlataformaService } from "../../generated/grpc/plataforma_catalogos_pb";
import { MunicipioResponse } from "../../response/comun/MunicipioResponse";
import { grpcCall, grpcClient } from "../grpc/grpcCall";

/** Municipios (gRPC-Web `CatalogosPlataformaService.ListMunicipios`). Lista cacheada en memoria toda la sesión (catálogo de solo lectura); dos
 *  llamadas simultáneas comparten el mismo request. */
export class MunicipioListService {
  static readonly instance = new MunicipioListService();
  private constructor() {}

  private _cache: MunicipioResponse[] | null = null;
  private _inflight: Promise<MunicipioResponse[]> | null = null;

  /** Lista completa (el servidor ya la manda sin eliminados y ordenada). */
  async get(): Promise<MunicipioResponse[]> {
    if (this._cache) return this._cache;
    if (this._inflight) return this._inflight;
    this._inflight = grpcCall(() => grpcClient(CatalogosPlataformaService).listMunicipios({}))
      .then((response) => {
        this._cache = response.items.map((m) => ({ id: m.id, departamentoId: m.departamentoId, nombre: m.nombre, isEliminado: false }));
        return this._cache;
      })
      .finally(() => {
        this._inflight = null;
      });
    return this._inflight;
  }
}
